import apolloClient from '@/graphql/apollo'
import { CALCULATE } from '@/graphql/mutations/shipping'

const calculate = async function(context, { destinationPostalCode, cartId }) {
  const response = await apolloClient.mutate({
    mutation: CALCULATE,
    variables: {
      cartId,
      destinationPostalCode
    }
  })

  context.commit('SET_SERVICES', { ...response.data.calculate })
}

const setDestinationPostalCode = (context, destinationPostalCode) => {
  context.commit('SET_DESTINATION_POSTAL_CODE', destinationPostalCode)
}

const setCurrentService = (context, service) => {
  context.commit('SET_CURRENT_SERVICE', service)
}

const clean = (context) => context.commit('CLEAN')

export default {
  calculate,
  setDestinationPostalCode,
  setCurrentService,
  clean
}
